import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { AUTH_POST_REGISTER_URL, AUTH_VERIFY_EMAIL } from '../../config/api';
import http from '../../config/http';
import { _route } from '../../utils';
import Page from '../../layout/components/PageAuth.jsx';
import LogoColor from '../../assets/images/logo-master-color.png';
import verifyEmailLogo from '../../assets/images/verifyEmail.svg';
import greenTickLogo from '../../assets/images/success.svg';
import PopupModal from '../../components/common/PopupModal';
import RightContent from './common/ContentRightSignup';

const buttonStyles = {
  borderRadius: '10px',
  boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  width: '100%',
  padding: '10px 14px',
  color: '#fff',
  transition: '0.2s',
  marginTop: '1rem',
  fontWeight: '500',
  backgroundColor: '#5433FF',
  // borderColor: '#5433FF',
  // border: '1px solid #5433FF',
  fontFamily: 'Inter',
  letterSpacing: '0',
  textTransform: 'inherit',
  '&:hover': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
  '&:focus': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
  '&:visited': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
};

function VerifyEmail() {
  const [otp, setOtp] = useState('');
  const history = useHistory();
  const routeParams = useLocation().search;
  const searchParamsData = new URLSearchParams(routeParams);
  const email = searchParamsData.get('email');
  const [showStatus, setShowStatus] = useState(false);

  const verifyEmail = async () => {
    try {
      await http.post(AUTH_VERIFY_EMAIL, { email, otp }).then((res) => {
        if (res.data.status === 'success') {
          setShowStatus(true);
          window.location.href = _route('finishSignUp');
        }
      });
    } catch (error) {
      toast.error('Something went wrong! Please try after sometime.');
    }
  };

  const resendOtp = async () => {
    try {
      await http.post(AUTH_POST_REGISTER_URL, { email }).then(() => {
        toast.success(`Otp has been sent to ${email} successfully`);
      });
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  return (
    <>
      <Page title="Register">
        <Grid container className="auth_view">
          <Grid item lg={6} md={12} sm={12} xs={12} className="auth_view_content customScrollbar">
            <Grid container className="auth_view">
              <Grid item lg={12} md={12} sm={12} xs={12} className="auth_view_content">
                <div className="signup_holder">
                  <div className="web_show">
                    <a className="logo_reg" href="/">
                      <img src={LogoColor} alt="Logo" className="logo_auth" />
                    </a>
                  </div>
                </div>
                <div className="mob_show">
                  <div>
                    <a className="logo_reg" href="/">
                      <img src={LogoColor} alt="Logo" className="logo_auth" />
                    </a>
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: '100vh',
                  }}
                >
                  <img src={verifyEmailLogo} style={{ marginBottom: '10px' }} />
                  <div style={{ display: 'block', textAlign: 'center' }}>
                    <div className="verify-email-heading">Check your email</div>
                    <div style={{ margin: '10px 0px 28px', width: '340px', display: 'inline-block' }}>
                      Please check your email for a link (link is valid for 5 minutes) to complete your account creation or
                      enter the OTP sent to <span style={{ fontWeight: 500 }}>{email ?? 'your email'}</span>
                    </div>
                    <OtpInput
                      value={otp}
                      onChange={(otp) => setOtp(otp)}
                      numInputs={4}
                      isInputNum
                      shouldAutoFocus
                      separator="&nbsp;&nbsp;"
                      inputStyle={{
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        padding: '4px',
                        gap: '8px',
                        width: '85px',
                        height: '85px',
                        background: '#FFFFFF',
                        border: '2px solid #D6BBFB',
                        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                        borderRadius: '8px',
                        flex: 'none',
                        alignSelf: 'stretch',
                        fontFamily: "'Inter'",
                        fontStyle: 'normal',
                        fontWeight: 500,
                        fontSize: '48px',
                        lineHeight: '60px',
                        textAlign: 'center',
                        letterSpacing: '-0.02em',
                        color: '#5433FF',
                      }}
                      focusStyle={{
                        background: '#FFFFFF',
                        border: '1px solid #5433FF',
                        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                        borderRadius: '8px',
                      }}
                    />

                    <LoadingButton
                      fullWidth
                      size="large"
                      type="submit"
                      onClick={verifyEmail}
                      sx={buttonStyles}
                      variant="contained"
                      disabled={otp.length < 4}
                    >
                      Verify Email
                    </LoadingButton>
                    <p className="sectionPara" style={{ marginTop: '24px' }}>
                      Didn't recieve the email?{' '}
                      <span style={{ color: '#5433FF', textDecoration: 'underline', cursor: 'pointer' }} onClick={resendOtp}>
                        Click to resend
                      </span>
                      .
                    </p>

                    <div
                      onClick={() => history.push(_route('login.newUser', { newUser: true }))}
                      style={{ marginTop: '3rem', cursor: 'pointer' }}
                    >
                      <ArrowBackIcon
                        style={{ verticalAlign: 'middle', width: '16px', height: '16px', marginRight: '6px' }}
                      />
                      <span style={{ verticalAlign: 'middle', fontWeight: '500' }}>Back to Sign Up</span>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <RightContent />
        </Grid>
      </Page>
      <PopupModal openModal={showStatus} handleModalClose={() => setShowStatus(false)} fullWidth>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '2rem',
            textAlign: 'center',
          }}
        >
          <img src={greenTickLogo} />
          <div className="verify-email-success-heading">Email verified</div>
          <p className="sectionPara">
            Your email has been verified <br />
            successfully.
          </p>
          <div onClick={() => history.push(_route('login'))} style={{ marginTop: '1.2rem', cursor: 'pointer' }}>
            <span style={{ verticalAlign: 'middle', fontWeight: '500', opacity: 0.7 }}>Redirecting you...</span>
          </div>
        </div>
      </PopupModal>
    </>
  );
}

export default VerifyEmail;
